<template>
  <div class="index">
    <div
      class="indexwraphead"
      :style="{'background-image':background_url?'url('+background_url+')':''}"
    >
      <v-headtitle  :cart="cart" colorwhite="colorwhite" :title="title"></v-headtitle>
      <div class="indexwrapheadbox">
        <h2 v-if="banner_title">{{banner_title}}</h2>
        <a v-if="url&&text" :href="url" class="shopnow iconfont">{{text}}</a>
      </div>
    </div>
    <div class="indexwrapbody container" style="text-align: center">
      <div class="title">
        <h2>HOT SALES</h2>
        <v-line></v-line>
      </div>

      <div v-if="this.products.length">
        <v-commoditylistitem
          v-for=" (item,index) in this.products"
          :key="index"
          :products="item"
          :index="index"
        ></v-commoditylistitem>
      </div>
      <v-noproduct v-else></v-noproduct>
    </div>
    <div class="indexwrapbottom">
      <h2>Subscribe to our newsletter</h2>
      <p>A short sentence describing what someone will receive by subscribing</p>
      <v-line></v-line>
      <div class="emailaddress">
        <input type="text" placeholder="Your email" />
        <span>
          <i>SUBSCRIBE</i>
          <b class="iconfont icon-youjiantou1"></b>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "background_url",
    "title",
    "cart",
    "banner_title",
    "url",
    "text",
    "products",

  ],
  data() {
    return {};
  },
  mounted() {

  }
};
</script>
<style scoped lang='scss'>
.index {
  .indexwraphead {
    width: 100%;
    height: 100vh;
    background-image: url("https://cdn.shopify.com/s/files/1/0013/1301/3843/files/pirme_b9abd5d9-08c1-4958-9e7a-806df598a355_4472x.jpg?v=1533");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: relative;
    top: 0;
    left: 0;
    vertical-align: top;

    .indexwrapheadbox {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
      h2 {
        width: 100%;
        font-size: 64px;
        margin-bottom: 20px;
        text-align: center;
        color: white;
      }
      .shopnow {
        text-decoration: none;
        padding: 12px 20px;
        background: white;
        color: black;
        font-family: "Open Sans", sans-serif;
        font-weight: 600;
        font-style: normal;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding: 12px 20px;
        font-size: 0.86667em;
      }
    }
  }
  .indexwrapbody {
    margin-top: 60px;
    .title {
      text-align: center;
      font-family: "Open Sans", sans-serif;
      padding-bottom: 30px;
      h2 {
        font-size: 26px;
        color: #222323;
        margin: 0;
      }
    }
  }
  .indexwrapbottom {
    margin-top: 60px;
    padding: 60px 0;
    background-color: #e7e7e7;
    text-align: center;

    h2 {
      font-size: 26px;
    }

    p {
      font-size: 15px;
    }

    .emailaddress {
      width: 520px;
      margin: 0 auto;
      background: white;
      padding: 10px;
      text-align: left;
      display: flex;

      input {
        width: 5px;
        height: 45px;
        padding: 8px 10px;
        border: none;
        color: black;
        font-size: 1.4em;
        box-sizing: border-box;
        vertical-align: top;
        flex: 1;
        &:focus {
          border: 2px solid #a6c7ff;
          padding: 6px 8px;
        }
      }

      input::-webkit-input-placeholder {
        color: black;
      }

      input::-moz-input-placeholder {
        color: black;
      }

      input::-ms-input-placeholder {
        color: black;
      }

      span {
        display: inline-block;
        height: 45px;
        padding: 12px 20px;
        background: red;
        color: white;
        font-weight: 600;
        letter-spacing: 0.1em;
        cursor: pointer;

        b {
          display: none;
        }
      }

      span:hover {
        background: rgb(241, 34, 34);
      }
    }
  }

  @media screen and (max-width: 590px) {
    .indexwrapbottom {
      .emailaddress {
        width: 90%;

        span {
          i {
            display: none;
          }

          b {
            display: inline;
          }
        }
      }
    }
  }
}
</style>